<div class="session-espired-container">
    <div class="title-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="zip-title" cdkFocusInitial>Resolve Issues to Continue</div>
        <button mat-button class="toolbar-icon-button" (click)="onCancel()">
            <mat-icon class="material-icons dialog-closeicon">
                close
            </mat-icon>
        </button>
    </div>
    <div class="error-data">
        <div *ngFor="let data of formErrorsArray" class="field-title" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div>
                    <mat-icon class="error-form-icon">
                        priority_high
                    </mat-icon>
                </div>
                <div class="error-content">
                 {{getDisplayName(data.field)}}
                </div>
            </div>
          
            <div fxFlex="40" fxLayoutAlign="end center" class="error-field-message">{{getErrorMessage(data)}}</div>
         
        </div>
    </div>
</div>
